import type { AssetDetectionMetricsDto } from '@terra/shared-contracts-external-network';
import {
  DETECTION_VIEW,
  type DetectionMetricConfig,
  type DetectionView,
} from '@terra/ui-design-system';

export function buildAssetDetectionMetricConfigs({
  metrics,
  detectionView,
  findingsLabel,
  activeSignalsLabel,
  totalSignalsLabel,
  includeDetectionColumns = true,
}: {
  metrics: AssetDetectionMetricsDto | undefined;
  detectionView: DetectionView;
  findingsLabel: string;
  activeSignalsLabel: string;
  totalSignalsLabel: string;
  includeDetectionColumns?: boolean;
}): DetectionMetricConfig[] {
  const activeFindingsCount = metrics?.activeFindingsCount ?? 0;
  const inactiveFindingsCount = metrics?.inactiveFindingsCount ?? 0;
  const allFindingsCount =
    metrics?.allFindingsCount ?? activeFindingsCount + inactiveFindingsCount;
  const activeSignalsCount = metrics?.activeSignalsCount ?? 0;
  const inactiveSignalsCount = metrics?.inactiveSignalsCount ?? 0;
  const signalsCount =
    metrics?.signalsCount ?? activeSignalsCount + inactiveSignalsCount;
  const visibleFindingsCount =
    detectionView === DETECTION_VIEW.ACTIVE
      ? activeFindingsCount
      : allFindingsCount;
  const visibleSignalsCount =
    detectionView === DETECTION_VIEW.ACTIVE ? activeSignalsCount : signalsCount;

  if (!includeDetectionColumns) {
    return [];
  }

  return [
    {
      key: 'findings',
      metricType: 'finding',
      hasMetric: visibleFindingsCount > 0,
      activeMetric: activeFindingsCount,
      totalMetric: allFindingsCount,
      inactiveMetric: inactiveFindingsCount,
      activeLabel: findingsLabel,
      totalLabel: findingsLabel,
    },
    {
      key: 'signals',
      metricType: 'signal',
      hasMetric: visibleSignalsCount > 0,
      activeMetric: activeSignalsCount,
      totalMetric: signalsCount,
      inactiveMetric: inactiveSignalsCount,
      activeLabel: activeSignalsLabel,
      totalLabel: totalSignalsLabel,
    },
  ];
}
